import { createContext, useContext } from "react";
import type { SessionState } from "./session.types";

export const SessionContext = createContext<SessionState | undefined>(undefined);

/** Throws outside the provider (twosion-ui falls back to an empty session) so a missing provider fails loudly. */
export function useSession(): SessionState {
  const value = useContext(SessionContext);
  if (!value) throw new Error("useSession() must be used inside <SessionProvider>.");
  return value;
}
